import { FC } from "react";

interface Props {
    size?: number;
    type: "info" | "help";
}

const TooltipIcon: FC<Props> = ({ size = 20, type }) => {
    if (type === "info")
        return (
            <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle opacity="0.4" cx="10" cy="10" r="10" fill="white" fillOpacity="0.4" />
                <path
                    d="M11 5C11 5.55228 10.5523 6 10 6C9.44772 6 9 5.55228 9 5C9 4.44772 9.44772 4 10 4C10.5523 4 11 4.44772 11 5Z"
                    fill="white"
                    fillOpacity="0.4"
                />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M8.25 8C8.25 7.58579 8.58579 7.25 9 7.25H10C10.4142 7.25 10.75 7.58579 10.75 8V15C10.75 15.4142 10.4142 15.75 10 15.75C9.58579 15.75 9.25 15.4142 9.25 15V8.75H9C8.58579 8.75 8.25 8.41421 8.25 8Z"
                    fill="white"
                    fillOpacity="0.4"
                />
            </svg>
        );

    return (
        <svg width={size} height={size} viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                opacity="0.4"
                d="M6.92154 0.571247C8.2077 -0.190416 9.7923 -0.190416 11.0785 0.571247L15.9215 3.43932C17.2077 4.20099 18 5.6086 18 7.13192V12.8681C18 14.3914 17.2077 15.799 15.9215 16.5607L11.0785 19.4288C9.7923 20.1904 8.20769 20.1904 6.92154 19.4288L2.07846 16.5607C0.792305 15.799 0 14.3914 0 12.8681V7.13192C0 5.6086 0.792305 4.20099 2.07846 3.43932L6.92154 0.571247Z"
                fill="white"
                fillOpacity="0.4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 5.75C8.30964 5.75 7.75 6.30964 7.75 7C7.75 7.41421 7.41421 7.75 7 7.75C6.58579 7.75 6.25 7.41421 6.25 7C6.25 5.48122 7.48122 4.25 9 4.25C10.5188 4.25 11.75 5.48122 11.75 7C11.75 7.54634 11.5899 8.05757 11.3138 8.48663C11.1409 8.75537 10.9387 9.01194 10.7523 9.24363C10.7182 9.28601 10.6847 9.32749 10.6518 9.36825C10.4971 9.5597 10.3551 9.73544 10.2239 9.91577C9.90029 10.3605 9.75 10.6947 9.75 11V11.5C9.75 11.9142 9.41421 12.25 9 12.25C8.58579 12.25 8.25 11.9142 8.25 11.5V11C8.25 10.2007 8.64241 9.53977 9.01096 9.03325C9.16669 8.81923 9.33733 8.60814 9.4925 8.41619C9.52359 8.37775 9.55405 8.34007 9.58364 8.30329C9.76883 8.07313 9.92648 7.87065 10.0524 7.67495C10.1774 7.48068 10.25 7.24996 10.25 7C10.25 6.30964 9.69036 5.75 9 5.75Z"
                fill="white"
                fillOpacity="0.4"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 13.25C9.41421 13.25 9.75 13.5858 9.75 14V15C9.75 15.4142 9.41421 15.75 9 15.75C8.58579 15.75 8.25 15.4142 8.25 15V14C8.25 13.5858 8.58579 13.25 9 13.25Z"
                fill="white"
                fillOpacity="0.4"
            />
        </svg>
    );
};

export default TooltipIcon;
